import styled from 'styled-components';

/** Centers content and provides responsive padding */
export const Container = styled.div`
  max-width: 42rem; /* ~2xl */
  margin: 0 auto;
  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
  }
`;

/** Vertical stack with generous spacing */
export const Center = styled.div`
  text-align: center;
`;

/** Red circular icon wrapper */
export const ErrorCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

/** Large headline */
export const Title = styled.h1`
  margin: 0 0 8px 0;
  font-weight: 600;
  color: #231f20;
  font-size: 32px;
`;

/** Support copy */
export const Paragraph = styled.p`
  color: #231f20;
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 32px 0;
  b {
    font-weight: 600;
  }
`;

/** Soft card */
export const Card = styled.div`
  margin-bottom: 2rem;
  background: #ffffff;
  border: 2px solid #f1f1f1;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
`;

/** Card body padding */
export const CardBody = styled.div`
  padding: 1.5rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
  }
`;

/** Card heading */
export const NextStepsTitle = styled.h2`
  margin: 0 0 1rem 0;
  font-weight: 600;
  color: #231f20;
  font-size: 18px;
  text-align: left;
`;

/** Bullet list styled as vertical spacing */
export const Steps = styled.div`
  display: grid;
  gap: 0.75rem;
  color: #231f20;
`;

/** Each bullet item uses a leading dot */
export const StepItem = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.55;
  text-align: left;

  &:before {
    content: '•';
    color: #231f20;
    font-weight: 700;
    margin-right: 0.5rem;
  }

  b {
    font-weight: 600;
  }
`;

/** Outline button */
export const OutlineButton = styled.button`
  appearance: none;
  border: 1px solid #d1d5db; /* gray-300 */
  background: #ffffff;
  color: #374151; /* gray-700 */
  padding: 0.5rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 120ms ease;

  &:hover {
    background-color: #f9fafb; /* gray-50 */
  }
`;

/** Small inline arrow icon (SVG) */
export const ArrowIcon = styled.svg`
  width: 1rem;
  height: 1rem;
  stroke: currentColor;
  fill: none;
`;
